<template>
  <div class="list-wrapper scroll-y full-height">    
    <div class="search-container no-margin no-padding">
      <input class="item-search" type="text" v-model="query" placeholder="Search..."/>
    </div>
    <div class="search-category-container no-margin no-padding">
    </div>
    <ul class="item-list full-height">
      <li @click="select(item)" v-bind:key="item.id" v-for="item in items" :class="{'active': item.id === selected.id}">
        <pg-container sm="12" cls="p-l-0 p-t-0 p-r-0 p-b-0 no-margin full-height">
          <div class="m-l-10 list-item-code font-montserrat bold pull-left">{{ item.company }}</div>
          <div :class="{
            'pull-right': true, 
            'bold': true,
            'text-success': item.plan === 'free',
            'text-primary': item.plan === 'guru' && !isExpired(item),
            'text-warning': isExpired(item),
            }">{{ item.plan }}</div>
          <div class="clearfix"></div>
          <div class="list-item-bottom m-l-10 fs-12 font-montserrat">
            {{ item.name }}
            <div class="list-item-footer">                      
              {{ item.email }}                        
            </div>
          <div class="clearfix"></div>
        </div>
        </pg-container>
        <div class="clearfix"></div>                
      </li>
    </ul>
  </div>
</template>

<script>

  import _ from 'lodash'
  const URL = 'https://testapi.proximi.fi/control-api/organizations'

  export default {
    name: 'OrganizationList',
    data: () => ({   
      query: '',   
      selected: {}, 
      items: []
    }),
    created() {
      this.$watch('query', (value) => {        
        this.$query = value;
        if (this.query.length > 3) {          
          this.fetch();
        }
      })
    },
    mounted() {      
      this.fetch();
    },
    methods: {
      fetch: _.debounce(async function () {
        this.$params.order = 'registeredAt';
        this.$params.dir = 'desc';        
        this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.$auth.token}`;
        const response = await this.$http.get(URL, { params: this.$params });
        this.$pagination.update(response);
        this.items = response.data;
                
        if (this.selected) {
          const updated = this.items.find((i) => i.id === this.selected.id);
          if (updated) {
            this.select(updated);
          }
        }
      }, 300),
      select(item) {
        this.selected = item;
        this.$emit('selected', item);
      },
      isExpired(item) {        
        if (item.plan !== 'free' && this.hasSubscription(item)) {
          const subscription = this.getSubscription(item);
          return subscription.status === 'trialing' && (subscription.trial_end * 1000) < new Date().getTime();
        }

        return false;
      },
      getSubscription(item) {
        return item.stripe.subscriptions.data[0];
      },
      hasSubscription(item) {
        return item.stripe && item.stripe.subscriptions && item.stripe.subscriptions.data && item.stripe.subscriptions.data.length > 0;
      }
    }
  }
</script>

<style lang="sass">

  .list-wrapper {    
    overflow-y: scroll;
  }

  form.item-search {
    border-right: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    background-color: #fafafa;
  }
  ul.item-list {
    margin: 0;
    padding-left: 1px;
    padding-top: 1px;
    padding-bottom: 1px;
    background: #f6f6f6;
    border-right: 1px solid #e6e6e6;    

    li {
      border-bottom: 1px solid #e6e6e6;
      border-left: 5px solid #f3f3f3;
      background: #fcfcfc;
      list-style: none;
      padding: 6px 5px 6px 0;
      line-height: 18px;
      cursor: pointer;
      transition: all 0.5s ease;

      &:hover {
        background: white;
      }

      &.active {
        border-left: 5px solid #9B7AC3;
        background: white;
      }

      .radio label, .checkbox label {
        padding-left: 20px !important;
        margin-top: 5px;
      }
    }

    li.unpaid {
      border-right: 3px solid #F55753;
    }

    li.paid {
      border-right: 3px solid #10CFBD;
    }
  }

  .list-item-image {
    width: 100%;
    height: 70px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .list-item-footer {
    margin-top: 6px;
  }

  .search-container {
    padding-left: 10px;
    padding-right: 10px;
    background-color: #fafafa;

    .item-search {
      width: 100%;
      background: #fafafa;
      border: none;
      height: 50px;
      padding-left: 10px;
      padding-right: 10px;
      color: #f55753;
      font-weight: bold;
      border-bottom: 1px solid #eaeaea;
      border-right: 1px solid #eaeaea;
      &::placeholder {
        color: #4CB5AB;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// OrganizationList.vue?100cacdc